/**
 * Google Workspace 連携の接続情報設定 API — Frontend ローカル Contract
 *
 * Backend: `v2/src/it-force/api/app-setting/usecase/app-integration-gws-connection.api-contract.ts`
 * `@standandforce/api-contract` 未 publish 時は FE で Contract を保持する。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const ConnectionConfigOutputSchema = z.object({
  appIntegrationId: z.string(),
  workspaceDomain: z.string(),
  adminEmail: z.string(),
  updatedAt: z.string()
});
const PatchAppIntegrationGwsConnectionInputSchema = z.object({
  appIntegrationId: z.string(),
  workspaceDomain: z.string(),
  adminEmail: z.string()
});
export const patchAppIntegrationGwsConnectionRoute = oc.route({
  method: 'PATCH',
  path: '/v2/app-integrations/{appIntegrationId}/google-workspace-connection'
}).input(PatchAppIntegrationGwsConnectionInputSchema).output(ConnectionConfigOutputSchema);
const GetAppIntegrationGwsConnectionInputSchema = z.object({
  appIntegrationId: z.string()
});
export const getAppIntegrationGwsConnectionRoute = oc.route({
  method: 'GET',
  path: '/v2/app-integrations/{appIntegrationId}/google-workspace-connection'
}).input(GetAppIntegrationGwsConnectionInputSchema).output(ConnectionConfigOutputSchema.nullable());